module.exports = __webpack_public_path__ + "static/img/10_western_eastern_japan.85bc3631.png";